import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '4px',
    backgroundColor: theme.evPalette.mango[100],
    minWidth: '100%',
    margin: '0',
    '& .myev-MuiSvgIcon-root': {
      color: theme.evPalette.mango[700],
    },
    '& .myev-MuiAlert-message': {
      paddingTop: '6px',
    },
    '@media (min-width: 640px)': {
      minWidth: '372px',
      marginTop: '12px',
      marginBottom: '0px',
      marginLeft: '24px',
      marginRight: '24px',
    },
  },

  heading: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.evPalette.charcoal[900],
  },

  body: {
    fontFamily: 'Noto Sans',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.evPalette.charcoal[900],
  },
}));
